import {resetRouter} from '@/router/index'
import SIdentify from "@/components/pictureIdentity/SIdentify";

export default {
    name: "Register",
    props:['isShow'],
    components:{
        SIdentify
    },
    data() {
        return {
            // 注册标识 0：中文注册表单  1：英文注册表单
            registerFlag: 0,
            registerForm: {
                name: '',
                phone: '',
                verificationCode: '',
                cName: '',
                eName: '',
                location: ''
            },
            enRegisterForm: {
                userName: '',
                email: '',
                password: '',
                checkPassword: '',
                company_name: '',
                eName_en: '',
                location_en: '',
                enVerificationCode: ''
            },
            verificationCodeButtonDis: true,
            verificationCodeButtonName: '获取验证码',
            //  公司下拉列表
            companyList: [],
            // 临时验证码
            // tempVerificationCode: '',
            // 验证码禁用标识
            verificationCodeDis: true,
            // 英文注册时生成的验证码
            createdIdentifyCode: '',
            // 英文注册验证码基础数据
            baseIdentifyCode: '1234567890ABCDEFGHIJKLMNOPQRSTUVWXYZ'
        }
    },
    watch: {
        '$i18n.locale'(val) {
            this.registerFormChange(val);
        },
        'isShow'(val){
           if(!val){
               this. registerForm= {
                name: '',
                phone: '',
                verificationCode: '',
                cName: '',
                eName: '',
                location: ''
            };
            this.enRegisterForm={
                userName: '',
                email: '',
                password: '',
                checkPassword: '',
                company_name: '',
                eName_en: '',
                location_en: '',
                enVerificationCode: ''
            }
           }
        },
        "registerForm.cName"(value){
            for(let i =0; i<this.companyList.length;i++){
                if(value === this.companyList[i].company_name){
                    this.registerForm.eName = this.companyList[i].company_name_en;
                    break;
                }
            }
        }
    },
    mounted: function () {
        console.log(this.$i18n.locale);
        if(this.$i18n.locale ==='en'){
            this.registerFlag = 1;
            // 生成的随机验证码清空
            this.createdIdentifyCode = '';
            // 生成随机验证码
            this.makeCode(4);
        }else{
            this.registerFlag = 0;
        }
    },
    created() {
        // this.$i18n.locale = 'en';
        // this.registerFormChange(this.$i18n.locale);
        // this.registerFormChange('en');
        this.$axios.get('/api/accounts/company').then(response => {
            this.companyList = response.data.resultData;
            // 过滤掉WIFFA公司
            this.companyList = this.companyList.filter(item => item.company_name !== 'WIFFA');
        }).catch(e => {
            console.log(e);
            this.$message({
                message: this.$t('common.message.operateFail'),
                type: 'error',
                center: true
            });
        });
    },
    computed: {
        rules() {
            const checkPhone = (rule, value, callback) => {
                let phoneReg = /(^1[3|4|5|6|7|8|9]\d{9}$)|(^09\d{8}$)/;
                if (value == "") {
                    callback(new Error(this.$t('ch_register.message.phone')));
                    //引入methods中封装的检查手机格式的方法
                } else if (!phoneReg.test(value)) {
                    callback(new Error(this.$t('ch_register.message.errPhone')));
                } else {
                    callback();
                }
            };
            return {
                name: [
                    { required: true, message: this.$t('ch_register.message.name'), trigger: 'blur' },
                    { max: 50, message: this.$t('ch_register.message.tooLong') + 50, trigger: 'blur' }
                ],
                phone: [
                    { required: true, validator: checkPhone, trigger: 'blur' },
                    // { pattern: /^1[3-9]\d{9}$/, message: this.$t('ch_register.message.errPhone') }
                ],
                verificationCode: [
                    { required: true, message: this.$t('ch_register.message.verificationCode'), trigger: 'blur' }
                ],
                cName: [
                    { required: true, message: this.$t('ch_register.message.cName'), trigger: 'blur' }
                ],
                eName: [
                    { required: true, message: this.$t('ch_register.message.eName'), trigger: 'blur' }
                ],
                location: [
                    { required: true, message: this.$t('ch_register.message.location'), trigger: 'blur' },
                    { max: 100, message: this.$t('ch_register.message.tooLong') + 100, trigger: 'blur' }
                ]
            }
        },
        enRules() {
            const checkPassword = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error(this.$t('en_register.message.rePassword')));
                } else if (value !== this.enRegisterForm.password) {
                    callback(new Error(this.$t('en_register.message.checkPassword')));
                } else {
                    callback();
                }
                // setTimeout(() => {
                //     if (mailReg.test(value)) {
                //         callback()
                //     } else {
                //         callback(new Error(this.$t('userManage.message.email')))
                //     }
                // }, 100)
            };
            return {
                userName: [
                    { required: true, message: this.$t('en_register.message.name'), trigger: 'blur' },
                    { max: 50, message: this.$t('en_register.message.tooLong') + 50, trigger: 'blur' }
                ],
                password: [
                    { required: true, message: this.$t('en_register.message.password'), trigger: 'blur' },
                    { max: 255, message: this.$t('en_register.message.tooLong') + 255, trigger: 'blur' }
                ],
                checkPassword: [
                    { required: true, validator: checkPassword, trigger: 'blur' },
                    { max: 255, message: this.$t('en_register.message.tooLong') + 255, trigger: 'blur' }
                ],
                email: [
                    { required: true, message: this.$t('en_register.message.email'), trigger: 'blur' },
                    { type: 'email', message: this.$t('en_register.message.errEmail'), trigger: ['blur', 'change'] }
                ],
                eName_en: [
                    { required: true, message: this.$t('en_register.message.eName'), trigger: 'blur' }
                ],
                location_en: [
                    { required: true, message: this.$t('en_register.message.location'), trigger: 'blur' },
                    { max: 100, message: this.$t('en_register.message.tooLong') + 100, trigger: 'blur' }
                ],
                enVerificationCode: [
                    { required: true, message: this.$t('en_register.message.verificationCode'), trigger: 'blur' }
                ],
            }
        },
    },
    methods: {
        restEnForm(formName){
            this.$refs[formName].resetFields();
            // 生成的随机验证码清空
            this.createdIdentifyCode = '';
            // 生成随机验证码
            this.makeCode(4);
        },
        submitForm(formName) {
            if (this.registerForm.cName.toUpperCase().indexOf('WIFFA') !== -1 || this.registerForm.eName.toUpperCase().indexOf('WIFFA') !== -1) {
                this.$message({
                    message: this.$t('ch_register.message.notAllowRegister'),
                    type: 'warning',
                    center: true
                });
            }
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    const param = { ... this.registerForm };
                    param.company_name = param.cName;
                    param.userName = param.name;
                    // 手机号注册密码默认为手机号
                    param.password = param.phone;
                    // 校验公司中英文名称是否匹配
                    for (let i = 0; i < this.companyList.length; i++) {
                        if (param.cName === this.companyList[i].company_name && param.eName !== this.companyList[i].company_name_en) {
                            this.$message({
                                message: this.$t('ch_register.message.companyNameErr'),
                                type: 'warning',
                                center: true
                            });
                            return ;
                        }

                        if (param.cName !== this.companyList[i].company_name && param.eName === this.companyList[i].company_name_en) {
                            this.$message({
                                message: this.$t('ch_register.message.companyNameErr'),
                                type: 'warning',
                                center: true
                            });
                            return ;
                        }
                    }
                    // console.log(param);
                    // if (this.tempVerificationCode !== param.verificationCode) {
                    //     this.$message({
                    //         message: this.$t('ch_register.message.checkVerificationCode'),
                    //         type: 'error',
                    //         center: true
                    //     });
                    // } else {
                    this.$axios.post('/api/accounts/registor', param).then(response => {
                        let type = 'error';
                        let responseMsg = response.data.message;
                        if (response.data.status === '1') {
                            type = 'success';
                            // 清空临时验证码
                            // this.tempVerificationCode = '';
                            responseMsg = 'ch_register.message.regisSuccess';
                            this.cancel();
                            // 注册成功自动登录
                            let loginUrl = '';
                            if (this.registerFlag === 0) {
                                loginUrl = `/api/oauth/token?grant_type=sms&client_id=jbyclient&client_secret=jbysecret&phone=${param.phone}&smsCode=${param.verificationCode}`;
                            }
                            if (this.registerFlag === 1) {
                                loginUrl = `/api/oauth/token?grant_type=password&client_id=jbyclient&client_secret=jbysecret&username=${param.userName}&password=${param.password}`;
                            }
                            sessionStorage.setItem('registerFlag', this.registerFlag);
                            this.$axios.get(loginUrl)
                                .then((response) => {
                                    const token = response.data.access_token;
                                    sessionStorage.setItem('token', token);
                                    // 登录以后获取token中的菜单信息数据源
                                    // 根据用户获取菜单
                                    this.$axios.get('/api/accounts/allMenu').then(resAll => {
                                        sessionStorage.setItem('allMenu', JSON.stringify(resAll.data.resultData));
                                        this.$axios.get(`/api/accounts/menu`).then((res) => {
                                            const systems = res.data.resultData;
                                            if (systems && systems.length > 0) {
                                                const current = systems[0];
                                                // 处理多系统菜单及名称
                                                const currentSystem = {
                                                    zhName: current.systemName,
                                                    enName: current.systemEnName,
                                                    routeData: current.menulist,
                                                    code: current.systemCode
                                                };
                                                sessionStorage.setItem('currentSystem', JSON.stringify(currentSystem));
                                            }
                                            if (systems && systems.length > 1) {
                                                const other = systems[1];
                                                // 处理多系统菜单及名称
                                                const otherSystem = {
                                                    zhName: other.systemName,
                                                    enName: other.systemEnName,
                                                    routeData: other.menulist,
                                                    code: other.systemCode
                                                };
                                                sessionStorage.setItem('otherSystem', JSON.stringify(otherSystem));
                                            }
                                            // 根据用户登录的菜单动态处理路由
                                            resetRouter(sessionStorage.getItem('allMenu'), sessionStorage.getItem('currentSystem'));
                                            this.$router.push('/home');
                                        }).catch((e) => {
                                            console.log(e)
                                        });
                                    }).catch(e => {
                                        console.log(e);
                                        this.$message({
                                            message: this.$t('EM-101'),
                                            type: 'error',
                                            center: true
                                        });
                                    });

                                }).catch((exception) => {
                                console.log(exception);
                                // this.$message({
                                //     message: '用户名或密码错误',
                                //     type: 'error',
                                //     center: true
                                // });
                                // 验证码登录
                                if (this.loginlanguageFlag === 0) {
                                    this.$message({
                                        message: '手机号或验证码错误',
                                        type: 'error',
                                        center: true
                                    });
                                }
                                // 密码登录
                                if (this.loginlanguageFlag === 1) {
                                    this.$message({
                                        message: 'username or password error',
                                        type: 'error',
                                        center: true
                                    });
                                }
                            });
                        }
                        this.$message({
                            message: this.$t(responseMsg),
                            type: type,
                            center: true
                        });
                    }).catch(e => {
                        console.log(e);
                        this.$message({
                            message: this.$t('common.message.operateFail'),
                            type: 'error',
                            center: true
                        });
                    })
                    // }
                }
            });
        },
        submitEnForm(formName) {
            if (this.enRegisterForm.eName_en.toUpperCase().indexOf('WIFFA') !== -1) {
                this.$message({
                    message: this.$t('en_register.message.notAllowRegister'),
                    type: 'warning',
                    center: true
                });
            }
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.enRegisterForm.enVerificationCode !== this.createdIdentifyCode.toLowerCase()) {
                        this.$message({
                            message: this.$t('en_register.message.verificationCodeNotMatch'),
                            type: 'warning',
                            center: true
                        });
                        // 刷新验证码
                        this.refreshEnRegisterIdentifyCode();
                        return null;
                    }
                    const param = { ... this.enRegisterForm };
                    param.cName = this.enRegisterForm.company_name;
                    param.eName = this.enRegisterForm.eName_en;
                    param.location = this.enRegisterForm.location_en;
                    console.log(param);
                    this.$axios.post('/api/accounts/registor', param).then(response => {
                        let type = 'error';
                        let responseMsg = response.data.message;
                        if (response.data.status === '1') {
                            type = 'success';
                            responseMsg = 'en_register.message.regisSuccess';
                            this.cancel();
                            // 注册成功自动登录
                            let loginUrl = '';
                            if (this.registerFlag === 0) {
                                loginUrl = `/api/oauth/token?grant_type=sms&client_id=jbyclient&client_secret=jbysecret&phone=${param.phone}&smsCode=${param.verificationCode}`;
                            }
                            if (this.registerFlag === 1) {
                                loginUrl = `/api/oauth/token?grant_type=password&client_id=jbyclient&client_secret=jbysecret&username=${param.email}&password=${param.password}`;
                            }
                            sessionStorage.setItem('registerFlag', this.registerFlag);
                            this.$axios.get(loginUrl)
                                .then((response) => {
                                    const token = response.data.access_token;
                                    sessionStorage.setItem('token', token);
                                    // 登录以后获取token中的菜单信息数据源
                                    // 根据用户获取菜单
                                    this.$axios.get('/api/accounts/allMenu').then(resAll => {
                                        sessionStorage.setItem('allMenu', JSON.stringify(resAll.data.resultData));
                                        this.$axios.get(`/api/accounts/menu`).then((res) => {
                                            const systems = res.data.resultData;
                                            if (systems && systems.length > 0) {
                                                const current = systems[0];
                                                // 处理多系统菜单及名称
                                                const currentSystem = {
                                                    zhName: current.systemName,
                                                    enName: current.systemEnName,
                                                    routeData: current.menulist,
                                                    code: current.systemCode
                                                };
                                                sessionStorage.setItem('currentSystem', JSON.stringify(currentSystem));
                                            }
                                            if (systems && systems.length > 1) {
                                                const other = systems[1];
                                                // 处理多系统菜单及名称
                                                const otherSystem = {
                                                    zhName: other.systemName,
                                                    enName: other.systemEnName,
                                                    routeData: other.menulist,
                                                    code: other.systemCode
                                                };
                                                sessionStorage.setItem('otherSystem', JSON.stringify(otherSystem));
                                            }
                                            // 根据用户登录的菜单动态处理路由
                                            resetRouter(sessionStorage.getItem('allMenu'), sessionStorage.getItem('currentSystem'));
                                            this.$router.push('/home');
                                        }).catch((e) => {
                                            console.log(e)
                                        });
                                    }).catch(e => {
                                        console.log(e);
                                        this.$message({
                                            message: this.$t('EM-101'),
                                            type: 'error',
                                            center: true
                                        });
                                    });

                                }).catch((exception) => {
                                console.log(exception);
                                // this.$message({
                                //     message: '用户名或密码错误',
                                //     type: 'error',
                                //     center: true
                                // });
                                // 验证码登录
                                if (this.loginlanguageFlag === 0) {
                                    this.$message({
                                        message: '手机号或验证码错误',
                                        type: 'error',
                                        center: true
                                    });
                                }
                                // 密码登录
                                if (this.loginlanguageFlag === 1) {
                                    this.$message({
                                        message: 'username or password error',
                                        type: 'error',
                                        center: true
                                    });
                                }
                            });
                        }
                        this.$message({
                            message: this.$t(responseMsg),
                            type: type,
                            center: true
                        });
                    }).catch(e => {
                        console.log(e);
                        this.$message({
                            message: this.$t('common.message.operateFail'),
                            type: 'error',
                            center: true
                        });
                    })
                }
            });
        },
        // 退回到登录
        cancel() {
            // this.$router.push('/');
            console.log(this.$parent)
            this.$parent.$parent.dialogRegisteredVisible = false;
            // this.$parent.$parent.dialogLoginVisible = true;
            this.registerForm = {
                name: '',
                phone: '',
                verificationCode: '',
                cName: '',
                eName: '',
                location: ''
            };
            this.enRegisterForm = {
                email: '',
                userName: '',
                password: '',
                checkPassword: '',
                company_name: '',
                eName_en: '',
                location_en: '',
                enVerificationCode: ''
            };
            // 生成的随机验证码清空
            this.createdIdentifyCode = '';
            // 生成随机验证码
            this.makeCode(4);
        },
        getVerificationCode() {
            // console.log(this.registerForm.phone);
            this.verificationCodeButtonDis = true;
            const param = {};
            param.phone = this.registerForm.phone;
            this.$axios.get('/api/sendSms/send', { params: param }).then(response => {
                if (response.data.status === '1') {
                    // this.tempVerificationCode = response.data.resultData.smsCode;
                    this.$message({
                        message: this.$t('login.message.verificationCodeSendSuccess'),
                        type: 'success',
                        center: true
                    });
                    this.changeVerificationCodeButtonName();
                    this.verificationCodeDis = false;
                } else {
                    this.$message({
                        message: this.$t('login.message.verificationCodeSendFailure'),
                        type: 'error',
                        center: true
                    });
                }
            }).catch(e => {
                console.log(e);
                this.$message({
                    message: this.$t('login.message.verificationCodeSendFailure'),
                    type: 'error',
                    center: true
                });
            });
        },
        //验证码倒数600秒
        changeVerificationCodeButtonName() {
            let time = 120;
            let timer = setInterval(() => {
                if (time === 0) {
                    clearInterval(timer);
                    this.verificationCodeButtonName = this.$t('ch_register.getVerificationCode');
                    this.verificationCodeButtonDis = false;
                } else {
                    this.verificationCodeButtonDis = true;
                    this.verificationCodeButtonName = time + this.$t('ch_register.secondRetry');
                    time--;
                }
            }, 1000);
        },
        // 手机号变化
        phoneChange(formName) {
            this.$refs[formName].validateField('phone', (phoneIsValid) => {
                if (!phoneIsValid) {
                    this.verificationCodeButtonDis = false;
                } else {
                    this.verificationCodeButtonDis = true;
                }
            })
        },
        // 中文公司下拉列表可填可选
        cNameSelectBlur(e) {
            this.registerForm.cName = e.target.value
        },
        // 英文公司下拉列表可填可选e
        eNameSelectBlur(e) {
            this.registerForm.eName = e.target.value
        },
        registerFormChange(locale) {
            if (locale.indexOf('en') !== -1) {
                this.registerFlag = 1;
            } else {
                this.registerFlag = 0;
            }
        },
        // 英文注册公司可填可选
        enRegistCompanySelectBlur(e) {
            this.enRegisterForm.company_name = e.target.value;
            this.enRegisterForm.eName_en = e.target.value;
        },
        changeUserType(value) {
            // 根据页面选择国内客户或是国际客户显示不同的表单
            if (value === 1) {
                this.registerFlag = 1;
                this.$i18n.locale = 'en';
                this.$refs.registerForm.resetFields();
                // 生成的随机验证码清空
                this.createdIdentifyCode = '';
                // 生成随机验证码
                this.makeCode(4);
            } else {
                this.registerFlag = 0;
                this.$i18n.locale = 'zh';
                this.$refs.enRegisterForm.resetFields();
            }
        },

        // 英文注册验证码处理
        enRegisterRandomNum(min, max) {
            return Math.floor(Math.random() * (max - min) + min)
        },

        // 刷新英文注册验证码
        refreshEnRegisterIdentifyCode() {
            this.createdIdentifyCode = ''
            this.makeCode(4)
        },

        // 生成英文注册验证码
        makeCode(identifyCodeLength) {
            for (let i = 0; i < identifyCodeLength; i++) {
                this.createdIdentifyCode += this.baseIdentifyCode[ this.enRegisterRandomNum(0, this.baseIdentifyCode.length) ]
            }
        }
    }
}
